export const createUnidadeModel = ({
  id_unidade = '',
  unidade = '',
  qtde_unidade = 1,
  abreviacao = ''
} = {}) => ({
  id_unidade,
  unidade,
  qtde_unidade,
  abreviacao
});